import clsx from "clsx";
import { memo } from "react";

const Chip = ({
  children,
  color,
}: {
  children: string;
  color: "red" | "blue" | "orange" | "gray";
}) => {
  return (
    <span
      className={clsx(
        "mx-auto text-14 rounded-md h-[1.625rem] w-[3.125rem] inline-flex justify-center items-center",
        {
          "text-red bg-[#FFD5D5]": color === "red",
          "text-[#1730FE] bg-[#C1CDFF]": color === "blue",
          "text-[#FD7028] bg-[#FEDCC1]": color === "orange",
          "text-secondary bg-gray": color === "gray",
        },
      )}
    >
      {children}
    </span>
  );
};

export default memo(Chip);
